import api from './axiosConfig';
import { ChatMessage, Routine } from '../types/entities';

interface ChatResponse {
  message: string;
  createdAt: string;
  /** Rotinas que a IA recomendou nesta resposta — não foram salvas. */
  suggestedRoutines?: Routine[];
}

export const CHAVES_CHAT = {
  historico: ['chat', 'historico'] as const,
};

// ponytail: exceção ao "invalidar no service" — o hook escreve o histórico com
// `setQueryData` (mensagem do usuário aparece na hora e a resposta chega junto).
// Invalidar aqui custaria um GET extra a cada mensagem para o mesmo resultado.
const AiAgentService = {
  /**
   * POST /api/v1/ai/complex → ChatResponse
   * Envia uma mensagem para o agente e retorna a resposta.
   * Body: { message: string }
   */
  chat: (message: string): Promise<ChatResponse> =>
    api.post<ChatResponse>('/ai/complex', { message }).then((r) => r.data),

  /**
   * GET /api/v1/ai/complex/history → ChatMessage[]
   * Retorna o histórico de mensagens do usuário logado.
   */
  getHistory: (): Promise<ChatMessage[]> =>
    api.get<ChatMessage[]>('/ai/complex/history').then((r) => r.data),

  /**
   * DELETE /api/v1/ai/complex/history
   * Apaga todo o histórico de chat do usuário logado.
   */
  clearHistory: (): Promise<void> =>
    api.delete('/ai/complex/history').then(() => undefined),
};

export default AiAgentService;
